import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { store } from './store/store';
import './index.css';
import { App } from './App';

/* transmit node-module is compatible with react 17 at the time of dev (04/10/204)
 using ReactDOM to use the Transmit sdk yet still use react 18 for the UI app. 
 do not upgrade/remove ReactDOM before confirming the compatibility of transmit.
 */
ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('syfWalletContainer') as HTMLElement,
);
